<div class="mb-xxxs br-md card">
	<div class="d-f fd-c mt-xxxs mb-nano ml-xxxs mr-xxxs br-md">
		<div class="d-f ai-c mb-xxs">
			<span class="fs-xs fw-bold lh-xs to-ellipsis">
				Configurações de Segurança
			</span>
		</div>

		<div class="d-f line">
			<div class="security-option">
				<p class="fs-sm mb-xs">Autenticação de Dois Fatores (2FA)</p>
				<p class="security-option-description fs-xxs gray mb-sm">
					Quando ativado, os usuários desta organização precisarão de um segundo
					método de verificação ao fazer login.
				</p>
				<button
					mat-flat-button
					color="primary"
					(click)="toggleTwoFactor()"
					[disabled]="isLoading"
				>
					<mat-spinner
						*ngIf="isLoading"
						diameter="20"
						class="button-spinner"
					></mat-spinner>
					<span *ngIf="!isLoading">{{ getButtonText() }}</span>
				</button>
			</div>

			<!-- **** START: New Password Expiration Option **** -->
			<div class="d-f line">
				<div class="security-option">
					<p class="fs-sm mb-xs">Expiração de Senha (90 dias)</p>
					<p class="security-option-description fs-xxs gray mb-sm">
						Quando ativado, as senhas dos usuários desta organização expirarão a
						cada 90 dias, exigindo a redefinição.
					</p>
					<button
						mat-flat-button
						color="primary"
						(click)="togglePasswordExpiration()"
						[disabled]="isLoadingPasswordExpiration"
					>
						<mat-spinner
							*ngIf="isLoadingPasswordExpiration"
							diameter="20"
							class="button-spinner"
						></mat-spinner>
						<span *ngIf="!isLoadingPasswordExpiration">
							{{ getPasswordExpirationButtonText() }}
						</span>
					</button>
				</div>
			</div>
			<!-- **** END: New Password Expiration Option **** -->
		</div>
	</div>
</div>
